const AUTH_BASE_URL = (process.env.REACT_APP_AUTH_URL ?? '').replace(/\/$/, '');

const EXAMPLE_STATE = 'opaque-state-token';

export const formatAllowedHostsForForm = (hosts?: Array<string> | null): string[] => {
  const normalizedHosts = hosts?.map((host) => host.trim().toLowerCase()).filter(Boolean) ?? [];
  if (normalizedHosts.length === 0) {
    return [''];
  }

  return normalizedHosts;
};

export const parseAllowedHostEntry = (entry: string): string | null => {
  const trimmed = entry.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.includes('://')) {
    try {
      const url = new URL(trimmed);
      const host = url.hostname.trim().toLowerCase();
      return host.length > 0 ? host : null;
    } catch {
      return null;
    }
  }

  if (trimmed.includes('/') || trimmed.includes(':')) {
    return null;
  }

  return trimmed.toLowerCase();
};

export const normalizeAllowedHostsFromForm = (entries: Array<string> | null | undefined): string[] => {
  const hosts = (entries ?? [])
    .map(parseAllowedHostEntry)
    .filter((host): host is string => host != null);

  return [...new Set(hosts)];
};

export const buildExampleReturnUrl = (entries: Array<string> | null | undefined): string | null => {
  const hosts = normalizeAllowedHostsFromForm(entries);
  if (hosts.length === 0) {
    return null;
  }

  return `https://${hosts[0]}`;
};

export const buildEnrollmentStartUrl = (
  enrollmentKey: string,
  allowedEntries: Array<string> | null | undefined,
): string | null => {
  const returnUrl = buildExampleReturnUrl(allowedEntries);
  if (!returnUrl) {
    return null;
  }

  const params = new URLSearchParams({
    enrollment_key: enrollmentKey,
    return_url: returnUrl,
    state: EXAMPLE_STATE,
  });

  const path = `/AdvisorPptAccess/EnrollStart?${params.toString()}`;
  return AUTH_BASE_URL ? `${AUTH_BASE_URL}${path}` : path;
};

export const isValidAllowedHostEntry = (entry: string): boolean =>
  parseAllowedHostEntry(entry) != null;
